import React from "react";
import NoizFlaDesk from "../../assets/images/noiz-fla-desk.jpg";
import NoizFlaMobile from "../../assets/images/noiz-fla-mobile.jpg";

const Banner = () => {
  return (
    <main className="banner">
      <a
        href="https://playforacause.com.br/pt/campaign/dia-das-criancas-do-mengao-pfc?saleType=auction,fixed_price&campaign=dia-das-criancas-do-mengao-pfc"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="desk" src={NoizFlaDesk} alt="Dia das Crianças do Mengão - Play for a Cause" />
        <img className="mobile" src={NoizFlaMobile} alt="Dia das Crianças do Mengão - Play for a Cause" />
      </a>
    </main>
  );
};

export default Banner;
